import { format } from 'date-fns';

/**
 * Util function to format UTC date string from the backend
 *  whilst keeping them in UTC. The function also adds UTC to
 * the end of the string for clarity.
 */
export const formatUtcDateString = (date: string | number, utcDisabled?: boolean): string => {
  if (typeof date === 'string' && isNaN(Date.parse(date))) {
    return 'Invalid date';
  }

  const dateObject = new Date(date);

  const dateUTC = new Date(
    dateObject.getUTCFullYear(),
    dateObject.getUTCMonth(),
    dateObject.getUTCDate(),
    dateObject.getUTCHours(),
    dateObject.getUTCMinutes(),
  );
  const formattedDate = format(dateUTC, 'dd/MM/yyyy HH:mm');

  return `${formattedDate} ${utcDisabled === true ? '' : 'UTC'}`;
};
